import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './tanSelection.css'; // Add custom CSS for styling
import { Container } from 'react-bootstrap';
import NavigationWrapper from '../../components/sessionNavigation/navigationWrapper';
import { setTan, getComponentById, getComponentsBySlug } from '../../redux/slice/tanProfileSlice';
import { useModifyImageMutation, useUploadImageMutation } from '../../redux/services/filterApi';
import { setUUID, setLoading } from '../../redux/slice/filterSlice';
import { v4 } from 'uuid'
import { upload } from '@testing-library/user-event/dist/upload';
import { useRef } from 'react';
import Image from 'react-bootstrap/Image';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import TanFilterVideo from '../../components/TanFilterVideo/TanFilterVideo';


const TanSelection = () => {
  const { t } = useTranslation("translation", { keyPrefix: "tanSelection" });
  const filterData = useSelector((state) => state?.filter);
  const boothData = useSelector((state) => state?.tanProfile?.scannedBoothData);
  const rapidLevel = parseInt(useSelector((state) => getComponentById(state, 14))?.value)
  const tanLevel = parseInt(useSelector((state) => getComponentById(state, 1))?.level) || rapidLevel || 1;
  const dispatch = useDispatch()
  const [selectedCircle, setSelectedCircle] = useState(tanLevel);
  const rapid = !boothData || boothData?.last_booth_state?.inventory?.find((item) => item.sku === 404471)
  const componentData = useSelector((state) => getComponentsBySlug(state, rapid ? "rapid" : "base tan level")) || [];
  useEffect(() => {
    dispatch(setTan({level: tanLevel, component_value_id:componentData[tanLevel]?.id,  component: rapid ? 14 : 1}))
    // if (!uploadStarted.current && filterData.localImage && !filterData.upload && !filterData.imgUUID) {
    //   const uuid = v4();
    //   dispatch(setUUID(uuid));

    //   fetch(filterData.localImage)
    //     .then((res) => res.blob())
    //     .then((blob) => {
    //       const fileName = uuid + ".png"; // Specify your desired file name
    //       const file = new File([blob], fileName, { type: blob.type });
    //       const formData = new FormData();
    //       formData.append('file', file);
    //       uploadImage(formData);
    //       dispatch(setLoading(true))
    //     });

    //   uploadStarted.current = true; // Set flag to true after upload has started
    // }
  }, [])
  useEffect(() => {
    if (filterData.upload && !filterData.modifiedUrl && !filterData.loading) {
      circleClicked(1)
    }
  }, [filterData.loading])

  const circleClicked = (number) => {
    setSelectedCircle(number)
    console.log(boothData)
    dispatch(setTan({level: number, component_value_id:componentData[number-1].id, component: rapid ? 14 : 1}))
  }

  // const renderCircle = (number) => {
  //   const circleColors = ["#e4dace", "#dbccc0", "#d2c2b3", "#cab7a6", "#bca48f", "#b59b85", "#af937b", "#a98b71", "#967457", "#8b6647", "#805938", "#764d2a",]
  //   const isSelected = selectedCircle === number;
  //   let percent = (number * 100) / 12
  //   let remPercent = percent - 100;
  //   const circleSize = isWide ? "12vh" : "16vw"
  //   return (
  //     <div
  //       key={number}
  //       className={`circle ${isSelected ? 'selected' : ''}`}
  //       onClick={() => circleClicked(number)}
  //       style={{ background: circleColors[number - 1], width: circleSize, height: circleSize }}
  //     >
  //       <span className="circle-number">{number}</span>
  //     </div>
  //   );
  // };

  // const imgSize = isWide ? "40vh" : "80vw"
  return (
    <>
      <NavigationWrapper>
        <Container style={{ display:"flex", flexDirection:"column", height:"inherit" }}>
          <div className='session-header'>{t("selection.header", "CHOOSE THE SHADE OF YOUR SPRAY TAN")}</div>
          <TanFilterVideo embedded circleClicked={circleClicked} tanLevel={tanLevel} showRapid={rapid}/>
          {/* {filterData.localImage ?
            <TanFilterVideo circleClicked={circleClicked} tanLevel={tanLevel} /> :
            <><div className="tanContainer">
              <div className="tanRow">
                <div className='left-text'>{t("tanrow.light", "LIGHT")}</div>
                {Array.from({ length: 4 }, (_, i) => renderCircle(i + 1))}
              </div>
              <hr />
              <div className="tanRow">
                <div className='left-text'>{t("tanrow.medium", "Medium")}</div>
                {Array.from({ length: 4 }, (_, i) => renderCircle(i + 5))}
              </div>
              <hr />
              <div className="tanRow">
                <div className='left-text'>{t("tanrow.dark", "DARK")}</div>
                {Array.from({ length: 4 }, (_, i) => renderCircle(i + 9))}
              </div>
            </div></>} */}
        </Container>
      </NavigationWrapper>
    </>
  );
};

export default TanSelection;
